import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import GapTimers from "../../../../../components/Collections/GapTimers";

const breadcrumbStatic = [{
	name: 'Trip Fees',
	url: '/admin/tripfees',
	icon: 'dashboard'
}];

export default class Trip_Fees extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>

				<Objects.TripFees
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showButtons={this.props.roles.includes(10)}
				/>

			</div>


		)
	}
}